import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  maxDeviceInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 16,
    maxWidth: '90%',
  },
  maxDeviceListContainer: {},
  maxDeviceListTitle: {
    fontSize: 18,
    fontFamily: 'InterSemiBold',
    marginBottom: 12,
  },
});
